<template>
	<span>{{formatDate(date)}}</span>
</template>

<script>
export default {
  name: 'LongDate',
  components: {  },
  props: {
    date: String,
  },
  methods: {
  	formatDate(date) {
  		var dayName = new Date(date).toLocaleString('en-US',{weekday: 'long'})
  		var monthName = new Date(date).toLocaleString('en-US',{month: 'long'})
  		var dayNumber = new Date(date).toLocaleString('en-US',{day: '2-digit'})
  		return dayName + ', ' + monthName + ' ' + dayNumber
  	}
  }
}
</script>